import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import Vue from 'vue';
import Router from 'vue-router';
import { normalizeURL } from 'ufo';
import { interopDefault } from './utils';
import scrollBehavior from './router.scrollBehavior.js';

var _f027e468 = function _f027e468() {
  return interopDefault(import('../pages/account-verification/index.vue'
  /* webpackChunkName: "pages/account-verification/index" */
  ));
};

var _3cc35757 = function _3cc35757() {
  return interopDefault(import('../pages/bursaries/index.vue'
  /* webpackChunkName: "pages/bursaries/index" */
  ));
};

var _0535e25d = function _0535e25d() {
  return interopDefault(import('../pages/courses/index.vue'
  /* webpackChunkName: "pages/courses/index" */
  ));
};

var _9501f3ac = function _9501f3ac() {
  return interopDefault(import('../pages/events/index.vue'
  /* webpackChunkName: "pages/events/index" */
  ));
};

var _7d2dddae = function _7d2dddae() {
  return interopDefault(import('../pages/faqs/index.vue'
  /* webpackChunkName: "pages/faqs/index" */
  ));
};

var _11e1eb2c = function _11e1eb2c() {
  return interopDefault(import('../pages/forgot-password/index.vue'
  /* webpackChunkName: "pages/forgot-password/index" */
  ));
};

var _44cc4778 = function _44cc4778() {
  return interopDefault(import('../pages/general-preferences/index.vue'
  /* webpackChunkName: "pages/general-preferences/index" */
  ));
};

var _834ad43a = function _834ad43a() {
  return interopDefault(import('../pages/interviews/index.vue'
  /* webpackChunkName: "pages/interviews/index" */
  ));
};

var _c732a2b2 = function _c732a2b2() {
  return interopDefault(import('../pages/jobs/index.vue'
  /* webpackChunkName: "pages/jobs/index" */
  ));
};

var _61d8acf4 = function _61d8acf4() {
  return interopDefault(import('../pages/LoadTest.vue'
  /* webpackChunkName: "pages/LoadTest" */
  ));
};

var _237e5f4e = function _237e5f4e() {
  return interopDefault(import('../pages/login/index.vue'
  /* webpackChunkName: "pages/login/index" */
  ));
};

var _5b364d1d = function _5b364d1d() {
  return interopDefault(import('../pages/messages/index.vue'
  /* webpackChunkName: "pages/messages/index" */
  ));
};

var _0ffe339a = function _0ffe339a() {
  return interopDefault(import('../pages/mock-interviews/index.vue'
  /* webpackChunkName: "pages/mock-interviews/index" */
  ));
};

var _e71db19c = function _e71db19c() {
  return interopDefault(import('../pages/my-details/index.vue'
  /* webpackChunkName: "pages/my-details/index" */
  ));
};

var _54740088 = function _54740088() {
  return interopDefault(import('../pages/my-jobs/index.vue'
  /* webpackChunkName: "pages/my-jobs/index" */
  ));
};

var _64bfdc67 = function _64bfdc67() {
  return interopDefault(import('../pages/notification-preferences/index.vue'
  /* webpackChunkName: "pages/notification-preferences/index" */
  ));
};

var _6fe46fe6 = function _6fe46fe6() {
  return interopDefault(import('../pages/notifications/index.vue'
  /* webpackChunkName: "pages/notifications/index" */
  ));
};

var _7e07ce2d = function _7e07ce2d() {
  return interopDefault(import('../pages/saved-jobs/index.vue'
  /* webpackChunkName: "pages/saved-jobs/index" */
  ));
};

var _5414b198 = function _5414b198() {
  return interopDefault(import('../pages/settings/index.vue'
  /* webpackChunkName: "pages/settings/index" */
  ));
};

var _3e5464f2 = function _3e5464f2() {
  return interopDefault(import('../pages/university-management/index.vue'
  /* webpackChunkName: "pages/university-management/index" */
  ));
};

var _7d124d87 = function _7d124d87() {
  return interopDefault(import('../pages/welcome/index.vue'
  /* webpackChunkName: "pages/welcome/index" */
  ));
};

var _8755bb28 = function _8755bb28() {
  return interopDefault(import('../pages/account/create.vue'
  /* webpackChunkName: "pages/account/create" */
  ));
};

var _6deb0e7a = function _6deb0e7a() {
  return interopDefault(import('../pages/account/edit.vue'
  /* webpackChunkName: "pages/account/edit" */
  ));
};

var _0b840622 = function _0b840622() {
  return interopDefault(import('../pages/account/verify-university.vue'
  /* webpackChunkName: "pages/account/verify-university" */
  ));
};

var _5289e5f9 = function _5289e5f9() {
  return interopDefault(import('../pages/email-verification/backup-email/index.vue'
  /* webpackChunkName: "pages/email-verification/backup-email/index" */
  ));
};

var _5e7a893e = function _5e7a893e() {
  return interopDefault(import('../pages/jobs/applications/index.vue'
  /* webpackChunkName: "pages/jobs/applications/index" */
  ));
};

var _7e20dd70 = function _7e20dd70() {
  return interopDefault(import('../pages/profile/create.vue'
  /* webpackChunkName: "pages/profile/create" */
  ));
};

var _bd7dbeac = function _bd7dbeac() {
  return interopDefault(import('../pages/profile/cv/index.vue'
  /* webpackChunkName: "pages/profile/cv/index" */
  ));
};

var _46b1ba7e = function _46b1ba7e() {
  return interopDefault(import('../pages/profile/edit.vue'
  /* webpackChunkName: "pages/profile/edit" */
  ));
};

var _f0e111be = function _f0e111be() {
  return interopDefault(import('../pages/profile/progress.vue'
  /* webpackChunkName: "pages/profile/progress" */
  ));
};

var _4008ceb3 = function _4008ceb3() {
  return interopDefault(import('../pages/profile/cv/about-me/index.vue'
  /* webpackChunkName: "pages/profile/cv/about-me/index" */
  ));
};

var _3d54977c = function _3d54977c() {
  return interopDefault(import('../pages/profile/cv/additional/index.vue'
  /* webpackChunkName: "pages/profile/cv/additional/index" */
  ));
};

var _38700b03 = function _38700b03() {
  return interopDefault(import('../pages/profile/cv/education/index.vue'
  /* webpackChunkName: "pages/profile/cv/education/index" */
  ));
};

var _3b6e863c = function _3b6e863c() {
  return interopDefault(import('../pages/profile/cv/employability-awards/index.vue'
  /* webpackChunkName: "pages/profile/cv/employability-awards/index" */
  ));
};

var _619d43f6 = function _619d43f6() {
  return interopDefault(import('../pages/profile/cv/fluent-languages/index.vue'
  /* webpackChunkName: "pages/profile/cv/fluent-languages/index" */
  ));
};

var _4420e681 = function _4420e681() {
  return interopDefault(import('../pages/profile/cv/general-reference/index.vue'
  /* webpackChunkName: "pages/profile/cv/general-reference/index" */
  ));
};

var _aa3106b8 = function _aa3106b8() {
  return interopDefault(import('../pages/profile/cv/interests/index.vue'
  /* webpackChunkName: "pages/profile/cv/interests/index" */
  ));
};

var _e92212c6 = function _e92212c6() {
  return interopDefault(import('../pages/profile/cv/skills/index.vue'
  /* webpackChunkName: "pages/profile/cv/skills/index" */
  ));
};

var _44102656 = function _44102656() {
  return interopDefault(import('../pages/profile/cv/template/index.vue'
  /* webpackChunkName: "pages/profile/cv/template/index" */
  ));
};

var _5edeed44 = function _5edeed44() {
  return interopDefault(import('../pages/profile/cv/transport/index.vue'
  /* webpackChunkName: "pages/profile/cv/transport/index" */
  ));
};

var _72f5a19c = function _72f5a19c() {
  return interopDefault(import('../pages/profile/cv/upload/index.vue'
  /* webpackChunkName: "pages/profile/cv/upload/index" */
  ));
};

var _57b4a781 = function _57b4a781() {
  return interopDefault(import('../pages/profile/cv/work-experience/index.vue'
  /* webpackChunkName: "pages/profile/cv/work-experience/index" */
  ));
};

var _14e3d53c = function _14e3d53c() {
  return interopDefault(import('../pages/profile/cv/additional/achievement/index.vue'
  /* webpackChunkName: "pages/profile/cv/additional/achievement/index" */
  ));
};

var _2accb8af = function _2accb8af() {
  return interopDefault(import('../pages/profile/cv/additional/external-link/index.vue'
  /* webpackChunkName: "pages/profile/cv/additional/external-link/index" */
  ));
};

var _3afb94ba = function _3afb94ba() {
  return interopDefault(import('../pages/profile/cv/additional/external-links/index.vue'
  /* webpackChunkName: "pages/profile/cv/additional/external-links/index" */
  ));
};

var _a159ef6e = function _a159ef6e() {
  return interopDefault(import('../pages/profile/cv/education/additional/index.vue'
  /* webpackChunkName: "pages/profile/cv/education/additional/index" */
  ));
};

var _34716ad6 = function _34716ad6() {
  return interopDefault(import('../pages/profile/cv/education/school/index.vue'
  /* webpackChunkName: "pages/profile/cv/education/school/index" */
  ));
};

var _45a0e474 = function _45a0e474() {
  return interopDefault(import('../pages/profile/cv/education/tertiary/index.vue'
  /* webpackChunkName: "pages/profile/cv/education/tertiary/index" */
  ));
};

var _8c204094 = function _8c204094() {
  return interopDefault(import('../pages/profile/cv/employability-awards/checklist.vue'
  /* webpackChunkName: "pages/profile/cv/employability-awards/checklist" */
  ));
};

var _5443036e = function _5443036e() {
  return interopDefault(import('../pages/profile/cv/employability-awards/ChecklistItem.vue'
  /* webpackChunkName: "pages/profile/cv/employability-awards/ChecklistItem" */
  ));
};

var _52ede0d5 = function _52ede0d5() {
  return interopDefault(import('../pages/profile/cv/employability-awards/LogUpload.vue'
  /* webpackChunkName: "pages/profile/cv/employability-awards/LogUpload" */
  ));
};

var _6f06084a = function _6f06084a() {
  return interopDefault(import('../pages/profile/cv/additional/achievement/_id.vue'
  /* webpackChunkName: "pages/profile/cv/additional/achievement/_id" */
  ));
};

var _e381ca52 = function _e381ca52() {
  return interopDefault(import('../pages/profile/cv/additional/external-link/_id.vue'
  /* webpackChunkName: "pages/profile/cv/additional/external-link/_id" */
  ));
};

var _912eee1e = function _912eee1e() {
  return interopDefault(import('../pages/profile/cv/education/additional/_id.vue'
  /* webpackChunkName: "pages/profile/cv/education/additional/_id" */
  ));
};

var _442faa84 = function _442faa84() {
  return interopDefault(import('../pages/profile/cv/education/school/_id.vue'
  /* webpackChunkName: "pages/profile/cv/education/school/_id" */
  ));
};

var _514573dc = function _514573dc() {
  return interopDefault(import('../pages/profile/cv/education/tertiary/_id.vue'
  /* webpackChunkName: "pages/profile/cv/education/tertiary/_id" */
  ));
};

var _17eed5ae = function _17eed5ae() {
  return interopDefault(import('../pages/profile/cv/general-reference/_id.vue'
  /* webpackChunkName: "pages/profile/cv/general-reference/_id" */
  ));
};

var _a8ced3ae = function _a8ced3ae() {
  return interopDefault(import('../pages/profile/cv/work-experience/_id.vue'
  /* webpackChunkName: "pages/profile/cv/work-experience/_id" */
  ));
};

var _671d3dcc = function _671d3dcc() {
  return interopDefault(import('../pages/jobs/applications/_id/index.vue'
  /* webpackChunkName: "pages/jobs/applications/_id/index" */
  ));
};

var _68e2eec2 = function _68e2eec2() {
  return interopDefault(import('../pages/bursaries/_id/index.vue'
  /* webpackChunkName: "pages/bursaries/_id/index" */
  ));
};

var _136a95ea = function _136a95ea() {
  return interopDefault(import('../pages/interviews/_id.vue'
  /* webpackChunkName: "pages/interviews/_id" */
  ));
};

var _0d6a1e12 = function _0d6a1e12() {
  return interopDefault(import('../pages/jobs/_id/index.vue'
  /* webpackChunkName: "pages/jobs/_id/index" */
  ));
};

var _01821a76 = function _01821a76() {
  return interopDefault(import('../pages/messages/_id.vue'
  /* webpackChunkName: "pages/messages/_id" */
  ));
};

var _fed2055c = function _fed2055c() {
  return interopDefault(import('../pages/reset-password/_id.vue'
  /* webpackChunkName: "pages/reset-password/_id" */
  ));
};

var _e09ede7a = function _e09ede7a() {
  return interopDefault(import('../pages/bursaries/_id/application/index.vue'
  /* webpackChunkName: "pages/bursaries/_id/application/index" */
  ));
};

var _38db4813 = function _38db4813() {
  return interopDefault(import('../pages/jobs/_id/application/index.vue'
  /* webpackChunkName: "pages/jobs/_id/application/index" */
  ));
};

var _f9392c18 = function _f9392c18() {
  return interopDefault(import('../pages/index.vue'
  /* webpackChunkName: "pages/index" */
  ));
};

var emptyFn = function emptyFn() {};

Vue.use(Router);
export var routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior: scrollBehavior,
  routes: [{
    path: "/account-verification",
    component: _f027e468,
    name: "account-verification___en"
  }, {
    path: "/af/account-verification",
    component: _f027e468,
    name: "account-verification___af"
  }, {
    path: "/bursaries",
    component: _3cc35757,
    name: "bursaries___en"
  }, {
    path: "/af/bursaries",
    component: _3cc35757,
    name: "bursaries___af"
  }, {
    path: "/courses",
    component: _0535e25d,
    name: "courses___en"
  }, {
    path: "/af/courses",
    component: _0535e25d,
    name: "courses___af"
  }, {
    path: "/events",
    component: _9501f3ac,
    name: "events___en"
  }, {
    path: "/af/events",
    component: _9501f3ac,
    name: "events___af"
  }, {
    path: "/faqs",
    component: _7d2dddae,
    name: "faqs___en"
  }, {
    path: "/af/faqs",
    component: _7d2dddae,
    name: "faqs___af"
  }, {
    path: "/forgot-password",
    component: _11e1eb2c,
    name: "forgot-password___en"
  }, {
    path: "/af/forgot-password",
    component: _11e1eb2c,
    name: "forgot-password___af"
  }, {
    path: "/general-preferences",
    component: _44cc4778,
    name: "general-preferences___en"
  }, {
    path: "/af/general-preferences",
    component: _44cc4778,
    name: "general-preferences___af"
  }, {
    path: "/interviews",
    component: _834ad43a,
    name: "interviews___en"
  }, {
    path: "/af/interviews",
    component: _834ad43a,
    name: "interviews___af"
  }, {
    path: "/jobs",
    component: _c732a2b2,
    name: "jobs___en"
  }, {
    path: "/af/jobs",
    component: _c732a2b2,
    name: "jobs___af"
  }, {
    path: "/LoadTest",
    component: _61d8acf4,
    name: "LoadTest___en"
  }, {
    path: "/af/LoadTest",
    component: _61d8acf4,
    name: "LoadTest___af"
  }, {
    path: "/login",
    component: _237e5f4e,
    name: "login___en"
  }, {
    path: "/af/login",
    component: _237e5f4e,
    name: "login___af"
  }, {
    path: "/messages",
    component: _5b364d1d,
    name: "messages___en"
  }, {
    path: "/af/messages",
    component: _5b364d1d,
    name: "messages___af"
  }, {
    path: "/mock-interviews",
    component: _0ffe339a,
    name: "mock-interviews___en"
  }, {
    path: "/af/mock-interviews",
    component: _0ffe339a,
    name: "mock-interviews___af"
  }, {
    path: "/my-details",
    component: _e71db19c,
    name: "my-details___en"
  }, {
    path: "/af/my-details",
    component: _e71db19c,
    name: "my-details___af"
  }, {
    path: "/my-jobs",
    component: _54740088,
    name: "my-jobs___en"
  }, {
    path: "/af/my-jobs",
    component: _54740088,
    name: "my-jobs___af"
  }, {
    path: "/notification-preferences",
    component: _64bfdc67,
    name: "notification-preferences___en"
  }, {
    path: "/af/notification-preferences",
    component: _64bfdc67,
    name: "notification-preferences___af"
  }, {
    path: "/notifications",
    component: _6fe46fe6,
    name: "notifications___en"
  }, {
    path: "/af/notifications",
    component: _6fe46fe6,
    name: "notifications___af"
  }, {
    path: "/saved-jobs",
    component: _7e07ce2d,
    name: "saved-jobs___en"
  }, {
    path: "/af/saved-jobs",
    component: _7e07ce2d,
    name: "saved-jobs___af"
  }, {
    path: "/settings",
    component: _5414b198,
    name: "settings___en"
  }, {
    path: "/af/settings",
    component: _5414b198,
    name: "settings___af"
  }, {
    path: "/university-management",
    component: _3e5464f2,
    name: "university-management___en"
  }, {
    path: "/af/university-management",
    component: _3e5464f2,
    name: "university-management___af"
  }, {
    path: "/welcome",
    component: _7d124d87,
    name: "welcome___en"
  }, {
    path: "/af/welcome",
    component: _7d124d87,
    name: "welcome___af"
  }, {
    path: "/account/create",
    component: _8755bb28,
    name: "account-create___en"
  }, {
    path: "/af/account/create",
    component: _8755bb28,
    name: "account-create___af"
  }, {
    path: "/account/edit",
    component: _6deb0e7a,
    name: "account-edit___en"
  }, {
    path: "/af/account/edit",
    component: _6deb0e7a,
    name: "account-edit___af"
  }, {
    path: "/account/verify-university",
    component: _0b840622,
    name: "account-verify-university___en"
  }, {
    path: "/af/account/verify-university",
    component: _0b840622,
    name: "account-verify-university___af"
  }, {
    path: "/email-verification/backup-email",
    component: _5289e5f9,
    name: "email-verification-backup-email___en"
  }, {
    path: "/af/email-verification/backup-email",
    component: _5289e5f9,
    name: "email-verification-backup-email___af"
  }, {
    path: "/jobs/applications",
    component: _5e7a893e,
    name: "jobs-applications___en"
  }, {
    path: "/af/jobs/applications",
    component: _5e7a893e,
    name: "jobs-applications___af"
  }, {
    path: "/profile/create",
    component: _7e20dd70,
    name: "profile-create___en"
  }, {
    path: "/af/profile/create",
    component: _7e20dd70,
    name: "profile-create___af"
  }, {
    path: "/profile/cv",
    component: _bd7dbeac,
    name: "profile-cv___en"
  }, {
    path: "/af/profile/cv",
    component: _bd7dbeac,
    name: "profile-cv___af"
  }, {
    path: "/profile/edit",
    component: _46b1ba7e,
    name: "profile-edit___en"
  }, {
    path: "/af/profile/edit",
    component: _46b1ba7e,
    name: "profile-edit___af"
  }, {
    path: "/profile/progress",
    component: _f0e111be,
    name: "profile-progress___en"
  }, {
    path: "/af/profile/progress",
    component: _f0e111be,
    name: "profile-progress___af"
  }, {
    path: "/profile/cv/about-me",
    component: _4008ceb3,
    name: "profile-cv-about-me___en"
  }, {
    path: "/af/profile/cv/about-me",
    component: _4008ceb3,
    name: "profile-cv-about-me___af"
  }, {
    path: "/profile/cv/additional",
    component: _3d54977c,
    name: "profile-cv-additional___en"
  }, {
    path: "/af/profile/cv/additional",
    component: _3d54977c,
    name: "profile-cv-additional___af"
  }, {
    path: "/profile/cv/education",
    component: _38700b03,
    name: "profile-cv-education___en"
  }, {
    path: "/af/profile/cv/education",
    component: _38700b03,
    name: "profile-cv-education___af"
  }, {
    path: "/profile/cv/employability-awards",
    component: _3b6e863c,
    name: "profile-cv-employability-awards___en"
  }, {
    path: "/af/profile/cv/employability-awards",
    component: _3b6e863c,
    name: "profile-cv-employability-awards___af"
  }, {
    path: "/profile/cv/fluent-languages",
    component: _619d43f6,
    name: "profile-cv-fluent-languages___en"
  }, {
    path: "/af/profile/cv/fluent-languages",
    component: _619d43f6,
    name: "profile-cv-fluent-languages___af"
  }, {
    path: "/profile/cv/general-reference",
    component: _4420e681,
    name: "profile-cv-general-reference___en"
  }, {
    path: "/af/profile/cv/general-reference",
    component: _4420e681,
    name: "profile-cv-general-reference___af"
  }, {
    path: "/profile/cv/interests",
    component: _aa3106b8,
    name: "profile-cv-interests___en"
  }, {
    path: "/af/profile/cv/interests",
    component: _aa3106b8,
    name: "profile-cv-interests___af"
  }, {
    path: "/profile/cv/skills",
    component: _e92212c6,
    name: "profile-cv-skills___en"
  }, {
    path: "/af/profile/cv/skills",
    component: _e92212c6,
    name: "profile-cv-skills___af"
  }, {
    path: "/profile/cv/template",
    component: _44102656,
    name: "profile-cv-template___en"
  }, {
    path: "/af/profile/cv/template",
    component: _44102656,
    name: "profile-cv-template___af"
  }, {
    path: "/profile/cv/transport",
    component: _5edeed44,
    name: "profile-cv-transport___en"
  }, {
    path: "/af/profile/cv/transport",
    component: _5edeed44,
    name: "profile-cv-transport___af"
  }, {
    path: "/profile/cv/upload",
    component: _72f5a19c,
    name: "profile-cv-upload___en"
  }, {
    path: "/af/profile/cv/upload",
    component: _72f5a19c,
    name: "profile-cv-upload___af"
  }, {
    path: "/profile/cv/work-experience",
    component: _57b4a781,
    name: "profile-cv-work-experience___en"
  }, {
    path: "/af/profile/cv/work-experience",
    component: _57b4a781,
    name: "profile-cv-work-experience___af"
  }, {
    path: "/profile/cv/additional/achievement",
    component: _14e3d53c,
    name: "profile-cv-additional-achievement___en"
  }, {
    path: "/af/profile/cv/additional/achievement",
    component: _14e3d53c,
    name: "profile-cv-additional-achievement___af"
  }, {
    path: "/profile/cv/additional/external-link",
    component: _2accb8af,
    name: "profile-cv-additional-external-link___en"
  }, {
    path: "/af/profile/cv/additional/external-link",
    component: _2accb8af,
    name: "profile-cv-additional-external-link___af"
  }, {
    path: "/profile/cv/additional/external-links",
    component: _3afb94ba,
    name: "profile-cv-additional-external-links___en"
  }, {
    path: "/af/profile/cv/additional/external-links",
    component: _3afb94ba,
    name: "profile-cv-additional-external-links___af"
  }, {
    path: "/profile/cv/education/additional",
    component: _a159ef6e,
    name: "profile-cv-education-additional___en"
  }, {
    path: "/af/profile/cv/education/additional",
    component: _a159ef6e,
    name: "profile-cv-education-additional___af"
  }, {
    path: "/profile/cv/education/school",
    component: _34716ad6,
    name: "profile-cv-education-school___en"
  }, {
    path: "/af/profile/cv/education/school",
    component: _34716ad6,
    name: "profile-cv-education-school___af"
  }, {
    path: "/profile/cv/education/tertiary",
    component: _45a0e474,
    name: "profile-cv-education-tertiary___en"
  }, {
    path: "/af/profile/cv/education/tertiary",
    component: _45a0e474,
    name: "profile-cv-education-tertiary___af"
  }, {
    path: "/profile/cv/employability-awards/checklist",
    component: _8c204094,
    name: "profile-cv-employability-awards-checklist___en"
  }, {
    path: "/af/profile/cv/employability-awards/checklist",
    component: _8c204094,
    name: "profile-cv-employability-awards-checklist___af"
  }, {
    path: "/profile/cv/employability-awards/ChecklistItem",
    component: _5443036e,
    name: "profile-cv-employability-awards-ChecklistItem___en"
  }, {
    path: "/af/profile/cv/employability-awards/ChecklistItem",
    component: _5443036e,
    name: "profile-cv-employability-awards-ChecklistItem___af"
  }, {
    path: "/profile/cv/employability-awards/LogUpload",
    component: _52ede0d5,
    name: "profile-cv-employability-awards-LogUpload___en"
  }, {
    path: "/af/profile/cv/employability-awards/LogUpload",
    component: _52ede0d5,
    name: "profile-cv-employability-awards-LogUpload___af"
  }, {
    path: "/profile/cv/additional/achievement/:id",
    component: _6f06084a,
    name: "profile-cv-additional-achievement-id___en"
  }, {
    path: "/af/profile/cv/additional/achievement/:id",
    component: _6f06084a,
    name: "profile-cv-additional-achievement-id___af"
  }, {
    path: "/profile/cv/additional/external-link/:id?",
    component: _e381ca52,
    name: "profile-cv-additional-external-link-id___en"
  }, {
    path: "/af/profile/cv/additional/external-link/:id?",
    component: _e381ca52,
    name: "profile-cv-additional-external-link-id___af"
  }, {
    path: "/profile/cv/education/additional/:id",
    component: _912eee1e,
    name: "profile-cv-education-additional-id___en"
  }, {
    path: "/af/profile/cv/education/additional/:id",
    component: _912eee1e,
    name: "profile-cv-education-additional-id___af"
  }, {
    path: "/profile/cv/education/school/:id",
    component: _442faa84,
    name: "profile-cv-education-school-id___en"
  }, {
    path: "/af/profile/cv/education/school/:id",
    component: _442faa84,
    name: "profile-cv-education-school-id___af"
  }, {
    path: "/profile/cv/education/tertiary/:id",
    component: _514573dc,
    name: "profile-cv-education-tertiary-id___en"
  }, {
    path: "/af/profile/cv/education/tertiary/:id",
    component: _514573dc,
    name: "profile-cv-education-tertiary-id___af"
  }, {
    path: "/profile/cv/general-reference/:id?",
    component: _17eed5ae,
    name: "profile-cv-general-reference-id___en"
  }, {
    path: "/af/profile/cv/general-reference/:id?",
    component: _17eed5ae,
    name: "profile-cv-general-reference-id___af"
  }, {
    path: "/profile/cv/work-experience/:id?",
    component: _a8ced3ae,
    name: "profile-cv-work-experience-id___en"
  }, {
    path: "/af/profile/cv/work-experience/:id?",
    component: _a8ced3ae,
    name: "profile-cv-work-experience-id___af"
  }, {
    path: "/jobs/applications/:id",
    component: _671d3dcc,
    name: "jobs-applications-id___en"
  }, {
    path: "/af/jobs/applications/:id",
    component: _671d3dcc,
    name: "jobs-applications-id___af"
  }, {
    path: "/bursaries/:id",
    component: _68e2eec2,
    name: "bursaries-id___en"
  }, {
    path: "/af/bursaries/:id",
    component: _68e2eec2,
    name: "bursaries-id___af"
  }, {
    path: "/interviews/:id",
    component: _136a95ea,
    name: "interviews-id___en"
  }, {
    path: "/af/interviews/:id",
    component: _136a95ea,
    name: "interviews-id___af"
  }, {
    path: "/jobs/:id",
    component: _0d6a1e12,
    name: "jobs-id___en"
  }, {
    path: "/af/jobs/:id",
    component: _0d6a1e12,
    name: "jobs-id___af"
  }, {
    path: "/messages/:id",
    component: _01821a76,
    name: "messages-id___en"
  }, {
    path: "/af/messages/:id",
    component: _01821a76,
    name: "messages-id___af"
  }, {
    path: "/reset-password/:id?",
    component: _fed2055c,
    name: "reset-password-id___en"
  }, {
    path: "/af/reset-password/:id?",
    component: _fed2055c,
    name: "reset-password-id___af"
  }, {
    path: "/bursaries/:id/application",
    component: _e09ede7a,
    name: "bursaries-id-application___en"
  }, {
    path: "/af/bursaries/:id/application",
    component: _e09ede7a,
    name: "bursaries-id-application___af"
  }, {
    path: "/jobs/:id/application",
    component: _38db4813,
    name: "jobs-id-application___en"
  }, {
    path: "/af/jobs/:id/application",
    component: _38db4813,
    name: "jobs-id-application___af"
  }, {
    path: "/",
    component: _f9392c18,
    name: "index___en"
  }, {
    path: "/af",
    component: _f9392c18,
    name: "index___af"
  }],
  fallback: false
};
export function createRouter(ssrContext, config) {
  var base = config._app && config._app.basePath || routerOptions.base;
  var router = new Router(_objectSpread(_objectSpread({}, routerOptions), {}, {
    base: base
  })); // TODO: remove in Nuxt 3

  var originalPush = router.push;

  router.push = function push(location) {
    var onComplete = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : emptyFn;
    var onAbort = arguments.length > 2 ? arguments[2] : undefined;
    return originalPush.call(this, location, onComplete, onAbort);
  };

  var resolve = router.resolve.bind(router);

  router.resolve = function (to, current, append) {
    if (typeof to === 'string') {
      to = normalizeURL(to);
    }

    return resolve(to, current, append);
  };

  return router;
}